<template>
    <page-container>
        <form-container :title="formTitle">
            <permission-container :permissionId="permissionId" showTip>
                <el-form ref="roleForm" :model="roleForm" v-loading="loading" status-icon :rules="rules" label-width="100px">
                    <el-form-item label="角色名" prop="name">
                        <el-input v-model="roleForm.name" autocomplete="off" class="one-third-width"></el-input>
                    </el-form-item>
                    <el-form-item label="描述" prop="description">
                        <el-input type="textarea" v-model="roleForm.description" autocomplete="off" class="one-third-width"></el-input>
                    </el-form-item>
    <!--                <el-form-item label="是否禁用" prop="disabled">-->
    <!--                    <el-radio v-model="roleForm.disabled" label="0">可用</el-radio>-->
    <!--                    <el-radio v-model="roleForm.disabled" label="1">禁用</el-radio>-->
    <!--                </el-form-item>-->
                    <el-form-item label="权限" prop="permissionList">
                        <div class="half-width" style="border-radius: 4px; border: 1px solid #DCDFE6; padding: 0px 10px;">
                            <div v-for="group in permissionGroupList">
                                <span>{{group.caption}}</span>
                                <!--                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>-->
                                <!--                    <div style="margin: 15px 0;"></div>-->
                                <el-checkbox-group v-model="roleForm.permissionList" @change="handleCheckedPermissionsChange">
                                    <el-checkbox v-for="permission in group.permissionList" :label="permission.id" :key="permission.id">{{permission.caption}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>

                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="save">保存</el-button>
                    </el-form-item>
                </el-form>
            </permission-container>
        </form-container>
    </page-container>
</template>

<script>
import List from "@/components/table/List";
export default {
    name: "RoleEdit",
    data()
    {
        return {
            roleForm: {
                id: null,
                name: '',
                description: '',
                permissionList: [],
            },
            rules: {
                name: [
                    { required: true, message: '请输入角色名称', trigger: 'blur' },
                ],
                description: [
                    { required: false, message: '', trigger: 'blur' },
                ],
            },
            permissionGroupList: [],
            loading: false,
            permissionId: "System.Role.Add",
            formTitle: "添加角色"
        };
    },
    mounted()
    {
        // console.log('user edit mounted.', this.$route.query);
        return Fx.Promise.then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.formTitle = "编辑角色";
                this.permissionId = "System.Role.Edit";
                return Fx.Http.post("/system/role/get", {id: this.$route.query.id}).
                then((response)=>
                {
                    console.log(response);
                    if(response.isSuccess())
                    {
                        this.roleForm.id = response.getData("id");
                        this.roleForm.name = response.getData("name");
                        this.roleForm.description = response.getData('description');
                        this.roleForm.permissionList = response.getData('permissionList').map(p => p.permissionId);
                    }
                });
            }
        }).
        then(()=>
        {
            return Fx.Http.post("/system/permission/group/list").
            then((response) =>
            {
                if (response.isSuccess())
                {
                    return this.permissionGroupList = response.getData();
                }
                return this.showMessageError(response.getErrorMessage());
            });
        });

    },
    methods: {
        save()
        {
            console.log(this.roleForm);
            this.$refs.roleForm.validate(valid =>
            {
                if(!valid) return;
                this.loading = true;
                let savePath = "/system/role/add";
                if(this.roleForm.id)
                {
                    savePath = "/system/role/edit";
                }
                return Fx.Http.post(savePath, this.roleForm).
                then((resp)=>
                {
                    this.loading = false;
                    if(resp.isSuccess() && resp.getData("id"))
                    {
                        this.showMessageSuccess('保存成功',()=>
                        {
                            this.dispatchRouteBack();
                        });
                    }
                    else
                    {
                        this.showMessageError(resp.getErrorMessage());
                    }
                });
            });
        },
        handleCheckedPermissionsChange(ids) {
            // console.log("handleCheckedPermissionsChange >>>", ids);
            // this.selectedPermissionObj = {};
            // for (let id of ids) {
            //     this.selectedPermissionObj[id] = true;
            // }
            // console.log(">>>", this.roleForm.permissionList);
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/system/pages/role/Edit.vue